import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import { normalize } from '../middlewares/normalize';
import { validate } from '../middlewares/validate';
import { rgpd } from '../middlewares/rgpd';

export const configureStore = (preloadedState) =>
  createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(thunk, normalize, validate, rgpd)
  );

export default configureStore;
